import {
  Box,
  Link,
  List,
  ListItem,
  Typography,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Modal,
  Divider,
  Button,
  Tooltip,
  Grid,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect, useMemo, useState, useRef } from "react";
import { royaltiesPieChartCol } from "../../src/constant/color";
import useCountDown from "../../src/hooks/useCountDown";
import FAQs from "../Home/FAQs";
import FollowUs from "../Home/FollowUs";
// import Collectors from "../NFTPage/Collectors";
import songStyle from "./styles";
import NftCard from "./NftCard";
import { useMutation, useQuery } from "react-query";
import { API_BASE_URL, STRAPI_API_URL } from "../../src/constant/appConstants";
import fetcher from "../../src/dataProvider";
import ToolTipText from "../Common/ToolTipText";
import SocialShareComponent from "../Buttons/socialShareReferral";
import { useRouter } from "next/router";
import Head from "next/head";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { numFormatter, share } from "../../util/common";
import Popup from "../Popup";
import HowItWorks from "../Home/HowItWorks";
import ReactPlayer from "react-player";
import PerformanceGraph from "../Graph/performanceGraph";
import auth from "../Layout/util/auth";
import TagManager from "react-gtm-module";
import CapturePhone from "../../src/components/feature/auth/CapturePhone";
import ReturnCalculator from "../../components/RetrunCalculator";
import SnackBar from "../Common/SnackBar";
import { enquireNowGTMCTAClick } from "../../util/gtmutil";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiCircularProgress-root": {
      color: "#554c4c9e",
      zIndex: 1,
    },
  },
  activeCircular: {
    color: "#fff !important",
    zIndex: 10,
  },
}));

const SongDetails = ({ songPerformanceState, songDetails }) => {
  const router = useRouter();
  const data = songDetails.data[0];
  console.log(
    "🚀 ~ file: SongDetails.js ~ line 36 ~ data",
    data?.attributes?.asset_tiers?.data?.sort(
      (a, b) => a.attributes.tier_id - b.attributes.tier_id
    )
  );

  // const { days, hours, minutes, seconds, timeDiff1 } = useCountDown(
  //   data?.attributes?.lauch_date
  // );
  const timeDiff1 = "-11111";

  const classes = useStyles();

  const [songImg, setSongImg] = useState(
    data?.attributes?.additional_media_image?.data?.[0]?.attributes?.url
  );
  const [artistVideopopup, setArtistVideopopup] = useState(false);
  const [artistAudiopopup, setArtistAudiopopup] = useState(false);
  const [artistName, setArtistName] = useState(
    data?.attributes?.artists?.data[0]?.attributes?.slug
  );
  const [artistsongInfo, setArtistSongInfo] = useState([]);
  const [urlKey, setUrlKey] = useState("PPiO2SBZ7Rw");
  const [sportifyUrlKey, setSportifyUrlKey] = useState();
  const [isMobile, setIsMobile] = useState(true);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [nftLink, setNftLink] = useState();
  const [open, setOpen] = React.useState(false);
  const [thumbVideoActive, setThumbVideoActive] = useState(false);
  const [howitWorks, setHowitWorks] = useState(false);

  const [playedSeconds, setPlayedSeconds] = useState(0);
  const [totalDuration, setToalDuration] = useState(0);
  const [performanceEnabled, setPerformanceEnabled] = useState(false);

  const [isSongPlaying, setIsSongPlaying] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  const handleCloseTooltip = () => {
    setOpenTooltip(false);
  };

  const handleOpenTooltip = () => {
    setOpenTooltip(true);
  };

  // const {walletFund} = useSelector(state=>state.walletFund)
  // const dispatch = useDispatch()
  // useEffect(()=> {
  //   console.log("Wallet price ===", walletFund);
  //   dispatch(setWalletFund("my wallet price"));
  // }, walletFund)

  const handleClose = () => {
    setArtistVideopopup(false);
  };

  const handleOpen = (key) => {
    setUrlKey(key);
    setArtistVideopopup(true);
  };

  useEffect(() => {
    handleWindowSizeChange();
    x?.addEventListener("playing", () => setIsAudioPlaying(true));
    x?.addEventListener("pause", () => setIsAudioPlaying(false));
    x?.addEventListener("ended", () => setIsAudioPlaying(false));
    if (typeof window !== "undefined") {
      setNftLink(window.location.href);
    }
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
      x?.removeEventListener("ended", () => setIsAudioPlaying(false));
      x?.addEventListener("playing", () => setIsAudioPlaying(true));
      x?.addEventListener("pause", () => setIsAudioPlaying(false));
    };
  }, []);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth < 768);
  };
  const royalties = useMemo(() => {
    let totalUserTokens = 0;
    return data?.attributes?.asset_tiers?.data
      .map((royalty) => {
        const value =
          royalty.attributes?.revenue_share *
          royalty.attributes?.tier_max_supply;

        const obj = {
          title: `${royalty.attributes?.asset_tier_mnemonics}: ${value}%`,
          value,
          color: royaltiesPieChartCol[royalty.attributes.asset_tier_mnemonics],
        };
        totalUserTokens += obj.value;
        return obj;
      })
      .concat([
        {
          title: `Artist Share: ${100 - totalUserTokens}%`,
          value: 100 - totalUserTokens,
          color: royaltiesPieChartCol["Artist Share"],
        },
      ]);
  }, [data.attributes?.asset_tiers?.data]);

  // console.log("Print artist name === ", data?.attributes)

  const Url = "https://www.youtube.com/embed/";
  const SportifyUrl = "https://open.spotify.com/track/";

  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [trackProgress, setTrackProgress] = useState(0);
  const [percent, setPercent] = useState(0);
  const [description, setDescription] = useState(
    data.attributes?.Description.substring(0, 180)
  );
  const [showMore, setShowMore] = useState(isMobile ? false : true);
  const [calculator, setCalculator] = useState(false);
  const [enquireNowPopup, setEnquireNowPopup] = useState(false);

  const intervalRef = useRef();
  var x = typeof window != "undefined" && document?.getElementById("my-audio");
  function togglePlayAudio() {
    setDuration(x.duration);
    setCurrentTime(x.currentTime);
    if (isAudioPlaying) {
      setIsAudioPlaying(false);
      x.pause();
    } else {
      setIsAudioPlaying(true);
      startTimer();
      x.play();
    }
  }

  const [snackbar, setSnackbar] = useState({
    show: false,
    status: "",
    message: "",
  });
  const startTimer = () => {
    // Clear any timers already running

    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setTrackProgress(x.currentTime);
      let currentPercentage = x.duration
        ? `${(x.currentTime / x.duration) * 100}%`
        : "0%";
      setPercent(parseInt(currentPercentage));
    }, [1000]);
  };
  const { data: artistTopSongs } = useQuery(`${STRAPI_API_URL}/artists`, () =>
    fetcher.get(`${STRAPI_API_URL}/artists`, {
      params: {
        [`filters[slug]`]: artistName,
        populate: "*",
      },
    })
  );
  const handleOpenmodal = () => setOpen(true);
  const handleClosemodal = () => setOpen(false);

  useEffect(() => {
    if (artistTopSongs) {
      setArtistSongInfo(
        artistTopSongs?.data[0]?.attributes?.artist_top_songs?.data
      );
    }
  }, [artistTopSongs]);

  const handleReadMore = () => {
    if (showMore) {
      setDescription(data.attributes?.Description.substring(0, 170));
    } else {
      setDescription(data.attributes?.Description);
    }
    setShowMore(!showMore);
  };

  const artistSocialMediadata = artistTopSongs?.data[0]?.attributes;

  const [performanceData, setPerformanceData] = React.useState([]);

  const r = auth();

  const { mutate: checkNftPurchaseStatus } = useMutation(
    (id) =>
      fetcher.get(
        `${API_BASE_URL}/v1/user/${id}/check-nft-purchase?slug=${router?.asPath}`
      ),
    {
      onSuccess: (response) => {
        if (response?.hasNft) {
          let labels = songPerformanceState?.map((item) => {
            return item?.attributes?.stats_date;
          });
          let data1 = songPerformanceState?.map((item) => {
            return item?.attributes?.streams;
          });

          let temp = {
            labels: labels || [],
            datasets: [
              {
                label: "Song Views",
                data: data1 || [],
                borderColor: "#E14084",
                backgroundColor: "rgba(255, 99, 132, 0.5)",
              },
            ],
          };
          setPerformanceData(temp);
          setPerformanceEnabled(true);
        }
      },
      onError: (error) => {
        console.log("Error", error.response.data);
      },
    }
  );

  useEffect(() => {
    if (r?.token) {
      checkNftPurchaseStatus(r?.userId);
    } else {
      setPerformanceEnabled(false);
    }
  }, []);

  const { country_code } = useSelector((state) => state.layout);
  return (
    <Box sx={songStyle.featuredSongsSection}>
      {typeof data != "undefined" && (
        <Head>
          <title>{data?.attributes?.meta_page_title}</title>
          <meta
            name="description"
            content={data?.attributes?.meta_description}
          />
          {/* <meta name="keywords" content={data?.attributes?.meta_keywords} />
          <meta
            property="og:url"
            content={
              process.env.NEXT_PUBLIC_WEB_URL + data?.attributes?.meta_og_url
            }
          /> */}
          <meta property="og:image" content={data?.attributes?.meta_og_image} />
          <meta property="og:title" content={data?.attributes?.meta_og_title} />
          <meta
            property="og:description"
            content={data?.attributes?.meta_og_description}
          />
          <link rel="icon" href="/favicon.ico" />
        </Head>
      )}

      <Typography sx={songStyle.breadCrumb} component="p">
        <Link href="/">Home</Link> / Song Page
      </Typography>
      <Box sx={songStyle.featuredRowTop}>
        {/* <Box sx={songStyle.featuredSingleTitle}>
          <Typography component="p" sx={songStyle.songDate}>
            {moment(data?.attributes?.lauch_date).format("MMM DD, YYYY")}
          </Typography>
          <Box sx={songStyle.songNameContent}>
            <Typography component="p" sx={songStyle.songName}>
              {data?.attributes?.Title}
            </Typography>
            <Typography component="p" sx={songStyle.singerName}>
              <img
                src={`${
                  data?.attributes?.artists?.data[0]?.attributes
                    ?.image_thumbnail
                    ? data?.attributes?.artists?.data[0]?.attributes
                        .image_thumbnail
                    : "/images/nft/artist.png"
                }`}
                alt="img"
              />
              <Typography component="small">
                <Link
                  href={`/artist/${data?.attributes?.artists?.data[0]?.attributes?.slug}`}
                  sx={songStyle.artistName}
                >
                  {data?.attributes?.artists?.data[0]?.attributes?.name}
                </Link>
              </Typography>
            </Typography>
          </Box>
        </Box> */}
        {timeDiff1 >= 1 ? (
          <>
            <Box sx={songStyle.Dropping}>
              <Box sx={songStyle.shareContainer}>
                <Typography component="span">Dropping in</Typography>
                <Typography
                  component="span"
                  sx={songStyle.linkShare}
                  onClick={() => handleOpenmodal()}
                >
                  <Box
                    component="img"
                    width="24px"
                    height="24px"
                    src="/images/nft/upload-white.svg"
                  />
                  <Box component="span">Share</Box>
                </Typography>
              </Box>
              <Box sx={songStyle.countDown}>
                <Table sx={songStyle.tableCount}>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ color: "#fff" }} align="center">
                        <Typography variant="h4">{days}</Typography>
                        <Typography component="small">Days</Typography>
                      </TableCell>
                      <TableCell sx={{ color: "#fff" }} align="center">
                        <Typography variant="h4">{hours}</Typography>
                        <Typography component="small">Hours</Typography>
                      </TableCell>
                      <TableCell sx={{ color: "#fff" }} align="center">
                        <Typography variant="h4">{minutes}</Typography>
                        <Typography component="small">Min</Typography>
                      </TableCell>
                      <TableCell sx={{ color: "#fff" }} align="center">
                        <Typography variant="h4">{seconds}</Typography>
                        <Typography component="small">Sec</Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
              <Typography
                component="small"
                sx={songStyle.counterLine}
              ></Typography>
            </Box>
            <Box sx={songStyle.featuredRow} style={{ paddingTop: "0" }}>
              <Box sx={songStyle.featuredBoxSingle}>
                <Box sx={songStyle.featuredCardImageBoxSingle}>
                  <Box>
                    <List
                      sx={songStyle.songThumbnailList}
                      className="hidden-scroll-bar"
                    >
                      {data?.attributes?.additional_media_image?.data.map(
                        (item) => {
                          return (
                            <ListItem
                              key={item?.id}
                              className={
                                item?.attributes?.url == songImg && "active"
                              }
                            >
                              <Box
                                component="img"
                                src={item?.attributes?.url}
                                width="100%"
                                onClick={() => {
                                  setSongImg(item?.attributes?.url);
                                }}
                              />
                            </ListItem>
                          );
                        }
                      )}
                    </List>
                  </Box>
                  <Box sx={songStyle.imgLgContainer}>
                    <Box
                      component="img"
                      src={songImg}
                      alt=""
                      maxHeight="430px !important"
                    />
                  </Box>
                </Box>
                <Box sx={songStyle.featuredCardContentSingle}>
                  <Box sx={songStyle.songDetails}>
                    <Box>
                      <Typography component="p" sx={songStyle.songDescription}>
                        {data.attributes?.Description}
                      </Typography>
                      <Box sx={songStyle.featuredStats}>
                        <Box sx={songStyle.featuredLowestAsk}>
                          <Typography
                            component="small"
                            sx={songStyle.featuredCardSubTitle}
                          >
                            Price Range
                          </Typography>
                          {country_code == "IN" && (
                            <Typography
                              variant="h3"
                              sx={songStyle.featuredCardTitle}
                            >
                              ₹{Math.round(data?.attributes?.lowest_ask * 80)} -
                              ₹{Math.round(data.attributes?.highest_ask * 80)}
                            </Typography>
                          )}
                          {country_code == "OTHER" && (
                            <Typography
                              variant="h3"
                              sx={songStyle.featuredCardTitle}
                            >
                              ${data?.attributes?.lowest_ask} - $
                              {data.attributes?.highest_ask}
                            </Typography>
                          )}
                        </Box>
                        <Box sx={songStyle.featuredLowestAsk}>
                          <Typography
                            component="small"
                            sx={songStyle.featuredCardSubTitle}
                          >
                            Total NFTs &nbsp;&nbsp;
                          </Typography>
                          <Typography
                            variant="h3"
                            sx={songStyle.featuredCardTitle}
                          >
                            {data?.attributes?.total_tokens}
                          </Typography>
                        </Box>
                        {/* <Box sx={songStyle.featuredTokens}>
                          <Typography
                            component="small"
                            sx={songStyle.featuredCardSubTitle}
                            style={{ display: "block", textAlign: "right" }}
                          >
                            Plays needed for 1.5x{" "}
                            <Tooltip arrow title="Number of total plays (sum of streams / views of all streaming partners) needed to achieve an expected return of 1.5 times of invested amount. More plays means higher return." placement="top-start">
                            <Box mt={'-10px'} component="img" src="/images/token/info.svg" />
                          </Tooltip>
                          </Typography>
                          <Typography
                            variant="h3"
                            style={{ textAlign: "right" }}
                            sx={songStyle.featuredCardTitle}
                          >
                            <Typography variant="span">
                              400 Mn+
                              <Box
                                component="img"
                                src="/images/token/money-bag.svg"
                              />
                            </Typography>
                          </Typography>
                        </Box> */}
                      </Box>
                      <Box sx={songStyle.featuredStats}>
                        <Box sx={songStyle.featuredLowestAsk}>
                          <Typography
                            component="small"
                            sx={songStyle.featuredCardSubTitle}
                          >
                            Royalty Share{" "}
                            <Tooltip
                              arrow
                              title={
                                <ToolTipText text="Total % of Royalty Income (sum of royalty from all streaming partners) assigned by the Artist for distribution amongst all NFT holders. Respective NFT holders (Silver, Gold, Platinum) will get % Royalty income as defined in Ownership  per NFT respectively." />
                              }
                              placement="top-start"
                            >
                              <Box
                                mt={"-10px"}
                                component="img"
                                src="/images/token/info.svg"
                              />
                            </Tooltip>
                          </Typography>
                          <Typography
                            variant="h3"
                            sx={songStyle.featuredCardTitle}
                          >
                            {data?.attributes?.royalty_share}%
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={songStyle.buttonSet}>
                        {/* <RegisterNow id={data?.attributes?.id} /> */}
                        {/* <Link
                          href="#nfttoken"
                          sx={songStyle.featuredBuyNow}
                          onClick={() => {}}
                        >
                          View Details
                        </Link> */}
                        {/* <RegisterNow></RegisterNow> */}
                      </Box>
                      {/* <Typography component="p" sx={songStyle.songMsg}>
                        We’ll inform you as and when the sale of digital tokens
                        will start. would suggest to register the interest.
                      </Typography> */}
                    </Box>
                    {!isEmpty(data?.attributes?.audio_url) && (
                      <Box marginTop={"40px"}>
                        <audio
                          style={{
                            width: "100%",
                            marginBottom: "25px",
                            backgroundColor: "aliceblue",
                            borderRadius: "10px",
                          }}
                          id="my-video"
                          controls
                          controlsList="nodownload"
                          preload="auto"
                        >
                          <source
                            src={data?.attributes?.audio_url}
                            type="audio/mp3"
                          />
                        </audio>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </>
        ) : (
          <>
            <Box sx={songStyle.featuredRow} style={{ paddingTop: "0" }}>
              <Box sx={songStyle.featuredBoxSingle}>
                <Box sx={songStyle.featuredCardImageBoxSingle}>
                  <Box>
                    <List
                      sx={songStyle.songThumbnailList}
                      className="hidden-scroll-bar"
                    >
                      {data?.attributes?.additional_media_image?.data.map(
                        (item) => {
                          return (
                            <ListItem
                              key={item?.id}
                              className={
                                item?.attributes?.url == songImg && "active"
                              }
                              style={{ padding: "0 0 10px 0" }}
                            >
                              <Box
                                component="img"
                                src={item?.attributes?.url}
                                width="100%"
                                onClick={() => {
                                  setSongImg(item?.attributes?.url),
                                    setThumbVideoActive(false);
                                }}
                              />
                            </ListItem>
                          );
                        }
                      )}
                      <ListItem
                        style={{ padding: "0 0 10px 0" }}
                        className={thumbVideoActive && "active"}
                      >
                        <Box
                          component="img"
                          src={`https://img.youtube.com/vi/${data?.attributes?.youtube_embed_code}/0.jpg `}
                          width="100%"
                          onClick={() => {
                            setThumbVideoActive(true);
                            setSongImg(null);
                            x.pause();
                            setIsAudioPlaying(false);
                          }}
                        />
                        <Box
                          style={{
                            cursor: "pointer",
                            width: "24px",
                            height: "16px",
                            position: "absolute",
                            top: "45%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            border: "none",
                          }}
                          onClick={() => {
                            setThumbVideoActive(true);
                            setSongImg(null);
                            x.pause();
                            setIsAudioPlaying(false);
                          }}
                          component="img"
                          src="/images/token/yt.png"
                        />
                      </ListItem>
                    </List>
                  </Box>
                  <Box sx={songStyle.imgLgContainer}>
                    {thumbVideoActive ? (
                      <Box>
                        <ReactPlayer
                          onProgress={(progress) => {
                            setPlayedSeconds(progress?.playedSeconds);
                          }}
                          width={isMobile ? "100%" : "430px"}
                          height={isMobile ? "230px" : "230px"}
                          background={"transparent"}
                          controls
                          url={Url + data?.attributes?.youtube_embed_code}
                          playing={isSongPlaying}
                          config={{
                            file: {
                              attributes: { controlsList: "nodownload" },
                            },
                          }}
                          onDuration={(duration) => {
                            setToalDuration(duration);
                          }}
                          onPause={() => {
                            setIsSongPlaying(false);
                          }}
                          onPlay={() => {
                            setIsSongPlaying(true);
                          }}
                        />
                      </Box>
                    ) : (
                      <Box>
                        <Box
                          component="img"
                          src={songImg}
                          alt=""
                          maxHeight="430px !important"
                          width="430px !important"
                        />

                        <Box
                          sx={{
                            top: 60,
                            right: isMobile ? 10 : 80,
                            position: "absolute",
                            display: "flex",
                            color: "white",
                          }}
                        >
                          {Math.abs(Number(data?.attributes?.ytube_views)) /
                            1.0e6 >
                            0 && (
                            <Typography component="p" sx={songStyle.views}>
                              Crossed <br />{" "}
                              {(
                                Math.abs(
                                  Number(data?.attributes?.ytube_views)
                                ) / 1.0e6
                              ).toFixed(0) + " Mn+"}{" "}
                              <br />{" "}
                              <span
                                style={{
                                  fontSize: "14px",
                                  textAlign: "center",
                                }}
                              >
                                Views
                              </span>
                            </Typography>
                          )}
                        </Box>

                        <Box
                          style={{
                            position: "absolute",
                            left: "50%",
                            top: "45%",
                            cursor: "pointer",
                          }}
                          onClick={() => togglePlayAudio()}
                        >
                          <Box
                            sx={{
                              position: "relative",
                              display: "inline-flex",
                            }}
                            className={classes.root}
                          >
                            <CircularProgress
                              variant="determinate"
                              value={100}
                              style={{
                                color: "#554c4c9e !important",
                                height: "52px",
                                width: "52px",
                                zIndex: 1,
                                position: "absolute",
                                right: "0",
                              }}
                            />
                            <CircularProgress
                              variant="determinate"
                              value={percent}
                              className={classes.activeCircular}
                              style={{
                                height: "52px",
                                width: "52px",
                                zIndex: 10,
                              }}
                            />

                            <Box
                              sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: "absolute",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Box
                                component="img"
                                style={{
                                  height: "16px",
                                  width: "12px",
                                  borderRadius: "0px",
                                }}
                                src={
                                  isAudioPlaying
                                    ? "/images/token/pause1.png"
                                    : "/images/token/play-white.png"
                                }
                              ></Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    )}

                    {!isMobile && (
                      <Box sx={songStyle.whatsAppDesktop}>
                        <Button
                          sx={songStyle.returnCalculator}
                          contained="solid"
                          onClick={() => {
                            setCalculator(true);
                            enquireNowGTMCTAClick(
                              r,"ctaClicks","loggedIn","Guest","Return Calculator")
                          }}
                        >
                          Return Calculator
                        </Button>
                        <Button
                          sx={songStyle.btnConfirm}
                          contained="solid"
                          onClick={() => setEnquireNowPopup(true)}
                        >
                          Enquire Now
                        </Button>
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box sx={songStyle.featuredCardContentSingle}>
                  <Box sx={songStyle.featuredSingleTitle}>
                    <Typography component="p" sx={songStyle.songDate}>
                      {moment(data?.attributes?.lauch_date).format(
                        "MMM DD, YYYY"
                      )}
                    </Typography>
                    <Box sx={songStyle.songNameContent}>
                      <Typography component="p" sx={songStyle.songName}>
                        {data?.attributes?.Title}
                      </Typography>
                      <Typography component="p" sx={songStyle.singerName}>
                        <img
                          src={`${
                            data?.attributes?.artists?.data[0]?.attributes
                              ?.image_thumbnail
                              ? data?.attributes?.artists?.data[0]?.attributes
                                  .image_thumbnail
                              : "/images/nft/artist.png"
                          }`}
                          alt="img"
                        />
                        <Typography component="small">
                          <Link
                            href={`/artist/${data?.attributes?.artists?.data[0]?.attributes?.slug}`}
                            sx={songStyle.artistName}
                          >
                            {
                              data?.attributes?.artists?.data[0]?.attributes
                                ?.name
                            }
                          </Link>
                        </Typography>
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={songStyle.songDetails}>
                    <Typography component="p" sx={songStyle.songDescription}>
                      {/* {data.attributes?.Description} */}
                      {description}
                      <span onClick={() => handleReadMore()}>
                        {showMore ? (
                          <span
                            style={{
                              color: "#E14084 !important",
                              cursor: "pointer",
                            }}
                          >
                            Less
                          </span>
                        ) : (
                          <span
                            style={{
                              color: "#E14084 !important",
                              cursor: "pointer",
                            }}
                          >
                            More{"..."}
                          </span>
                        )}
                      </span>
                    </Typography>
                    <Box sx={songStyle.featuredStats}>
                      <Box sx={songStyle.featuredLowestAsk}>
                        <Typography
                          component="small"
                          sx={songStyle.featuredCardSubTitle}
                        >
                          Price Range
                        </Typography>
                        {country_code == "IN" && (
                          <Typography
                            variant="h3"
                            sx={songStyle.featuredCardTitle}
                          >
                            ₹{Math.round(data?.attributes?.lowest_ask * 80)} - ₹
                            {Math.round(data.attributes?.highest_ask * 80)}
                          </Typography>
                        )}
                        {country_code == "OTHER" && (
                          <Typography
                            variant="h3"
                            sx={songStyle.featuredCardTitle}
                          >
                            ${data?.attributes?.lowest_ask} - $
                            {data.attributes?.highest_ask}
                          </Typography>
                        )}
                      </Box>
                      <Box sx={songStyle.featuredTokens}>
                        <Typography
                          component="small"
                          sx={songStyle.featuredCardSubTitle}
                          style={{ display: "block", textAlign: "right" }}
                        >
                          Total NFTs{" "}
                        </Typography>
                        <Typography
                          variant="h3"
                          style={{ textAlign: "right" }}
                          sx={songStyle.featuredCardTitle}
                        >
                          <Typography variant="span">
                            {data?.attributes?.total_tokens}
                          </Typography>
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={songStyle.featuredStats}>
                      <Box sx={songStyle.featuredLowestAsk}>
                        <Typography
                          component="small"
                          sx={songStyle.featuredCardSubTitle}
                        >
                          Royalty Share{" "}
                          <Tooltip
                            enterTouchDelay={0}
                            leaveTouchDelay={6000}
                            arrow
                            title={
                              <ToolTipText text="Total % of Royalty Income (sum of royalty from all streaming partners) assigned by the Artist for distribution amongst all NFT holders. Respective NFT holders (Silver, Gold, Platinum) will get % Royalty income as defined in Ownership  per NFT respectively." />
                            }
                            placement="top-start"
                            TransitionProps={{ leavedelay: 5000 }}
                          >
                            <Box
                              mt={"-10px"}
                              component="img"
                              src="/images/token/info.svg"
                            />
                          </Tooltip>
                        </Typography>
                        <Typography
                          variant="h3"
                          sx={songStyle.featuredCardTitle}
                        >
                          {data?.attributes?.royalty_share}%
                        </Typography>
                      </Box>
                      <Box sx={songStyle.featuredTokens}>
                        <Typography
                          component="small"
                          sx={songStyle.HItWork}
                          style={{ cursor: "pointer" }}
                          onClick={() => setHowitWorks(true)}
                        >
                          How it Works!
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={songStyle.buttonSet}></Box>
                    {!isEmpty(data?.attributes?.audio_url) && (
                      <audio
                        style={{
                          width: "100%",
                          // marginLeft:'55px',
                          marginTop: "30px",
                          backgroundColor: "aliceblue",
                          borderRadius: "10px",
                        }}
                        id="my-audio"
                        controls
                        controlsList="nodownload"
                        preload="auto"
                      >
                        <source
                          src={data?.attributes?.audio_url}
                          type="audio/mp3"
                        />
                      </audio>
                    )}

                    {(data?.attributes?.spotify_track_id ||
                      data?.attributes?.youtube_embed_code) && (
                      <Typography
                        component="p"
                        sx={songStyle.songMsg}
                        style={{
                          textAlign: "center",
                          marginTop: "11px",
                        }}
                      >
                        {data?.attributes?.song_preview_youtube_text}{" "}
                        {data?.attributes?.spotify_track_id && (
                          <Box
                            component="img"
                            src="/images/token/spotify-logo.svg"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setArtistAudiopopup(true);
                              setSportifyUrlKey(
                                data?.attributes?.spotify_track_id
                              );
                              window.open(
                                SportifyUrl +
                                  data?.attributes?.spotify_track_id,
                                "_blank"
                              );
                            }}
                          />
                        )}{" "}
                        {data?.attributes?.youtube_embed_code && (
                          <Box
                            style={{ cursor: "pointer" }}
                            component="img"
                            src="/images/token/youtube-logo.svg"
                            onClick={() =>
                              handleOpen(data?.attributes?.youtube_embed_code)
                            }
                          />
                        )}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </>
        )}
        {performanceEnabled ? (
          <>
            {performanceData?.labels?.length > 0 && (
              <Box sx={songStyle.featuredRow}>
                <PerformanceGraph
                  songName={data?.attributes?.Title}
                  songPerformance={performanceData}
                  totalStreams={numFormatter(
                    performanceData?.datasets?.[0].data?.[
                      performanceData?.datasets?.[0].data?.length - 1
                    ]
                  )}
                ></PerformanceGraph>
              </Box>
            )}
          </>
        ) : (
          <Box sx={songStyle.featuredRow}>
            <Typography variant="h3" sx={songStyle.performanceTitle}>
              Current Stats - {data?.attributes?.Title}
            </Typography>
            <Box sx={songStyle.performanceContainer}>
              <Box component="img" src="/images/token/lock.svg" />{" "}
              &nbsp;&nbsp;&nbsp;
              <Typography variant="p" sx={songStyle.performanceText}>
                Buy {data?.attributes?.Title} NFT to unlock
              </Typography>
            </Box>
          </Box>
        )}

        {/* {Math.abs(Number(data?.attributes?.ytube_views)) / 1.0e6 > 0 && (
          <Box sx={songStyle.featuredRow}>
            <Typography component="p" sx={songStyle.tokenSectionTitle}>
              Song Performance
            </Typography>
            <Box sx={songStyle.boxRow}>
              {isMobile ? (
                <>
                  <Table sx={songStyle.tableUI}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          variant="th"
                          width="250px !important"
                          style={{ paddingLeft: "16px" }}
                        >
                          Song Name
                        </TableCell>
                        <TableCell width="90px" variant="th">
                          YouTube
                        </TableCell>
                        <TableCell width="90px" variant="th">
                          Spotify
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody sx={songStyle.tblBody}>
                      <TableRow key="1">
                        <TableCell width="200px">
                          <Typography component="p" sx={songStyle.releaseDate}>
                            {moment(data?.attributes?.song_launch_date).format(
                              "DD MMM YYYY"
                            )}
                          </Typography>
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              component="img"
                              src={data?.attributes?.image_url}
                            />
                            <Typography
                              component="p"
                              sx={songStyle.tblsongName}
                            >
                              {data?.attributes?.Title}
                              <br />
                              {(
                                Math.abs(
                                  Number(data?.attributes?.ytube_views)
                                ) / 1.0e6
                              ).toFixed(1) + "M"}{" "}
                              Total Streams
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell width="90px">
                          <Box
                            style={{ cursor: "pointer" }}
                            component="img"
                            src="/images/token/youtube.svg"
                            onClick={() =>
                              handleOpen(data?.attributes?.youtube_embed_code)
                            }
                          />
                        </TableCell>
                        <TableCell width="90px">
                          <Box
                            style={{ cursor: "pointer" }}
                            component="img"
                            src="/images/token/spotify.svg"
                            onClick={() => {
                              setArtistAudiopopup(true);
                              setSportifyUrlKey(
                                data?.attribute?.spotify_track_id
                              );
                              window.open(
                                SportifyUrl + data?.attribute?.spotify_track_id,
                                "_blank"
                              );
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </>
              ) : (
                <>
                  <Table sx={songStyle.DesktoptableUI}>
                    <TableHead>
                      <TableRow style={{ fontSize: "20px" }}>
                        <TableCell
                          variant="th"
                          width="250px"
                          style={{ paddingLeft: "16px" }}
                        >
                          Song Name
                        </TableCell>
                        <TableCell variant="th" width="100px">
                          Release
                        </TableCell>
                        <TableCell variant="th" width="100px">
                          Total Streams{" "}
                          <Tooltip
                            arrow
                            title={
                              <ToolTipText text="Sum of Streams for all streaming partners (Spotify, Gaana, Saavn, Wynk etc) and Total Views on Youtube." />
                            }
                            placement="top-start"
                          >
                            <Box
                              mt={"-10px"}
                              component="img"
                              src="/images/token/info.svg"
                            />
                          </Tooltip>
                        </TableCell>
                        <TableCell variant="th" width="100px">
                          YouTube
                        </TableCell>
                        <TableCell variant="th" width="100px">
                          Spotify
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      <TableRow key="1">
                        <TableCell
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Box
                            component="img"
                            src={data?.attributes?.image_url}
                            style={{
                              width: "70px",
                              height: "70px",
                              border: "1px solid #FFFFFF",
                              borderRadius: "4px",
                            }}
                          />
                          <Typography
                            component="p"
                            sx={songStyle.DesktopTblsongName}
                          >
                            {data?.attributes?.Title}
                          </Typography>
                        </TableCell>
                        <TableCell width="100px">
                          {moment(data?.attributes?.song_launch_date).format(
                            "DD MMM YYYY"
                          )}
                        </TableCell>
                        <TableCell width="100px">
                          {(
                            Math.abs(Number(data?.attributes?.ytube_views)) /
                            1.0e6
                          ).toFixed(0) + " Mn+"}
                        </TableCell>
                        <TableCell width="100px">
                          <Box
                            style={{ cursor: "pointer" }}
                            component="img"
                            src="/images/token/youtube.svg"
                            onClick={() =>
                              handleOpen(data?.attributes?.youtube_embed_code)
                            }
                          />
                        </TableCell>

                        <TableCell width="100px">
                          <Box
                            style={{ cursor: "pointer" }}
                            component="img"
                            src="/images/token/spotify.svg"
                            onClick={() => {
                              setArtistAudiopopup(true);
                              setSportifyUrlKey(
                                data?.attribute?.spotify_track_id
                              );
                              window.open(
                                SportifyUrl + data?.attribute?.spotify_track_id,
                                "_blank"
                              );
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </>
              )}
              <Modal open={artistVideopopup} onClick={handleClose}>
                <Box sx={songStyle.SongVideos}>
                  <iframe
                    width="640"
                    height="320"
                    src={
                      Url + data?.attributes?.youtube_embed_code + "?autoplay=1"
                    }
                    title="Top 5 Songs"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </Box>
              </Modal>
            </Box>
          </Box>
        )} */}
        <Box sx={songStyle.featuredRow}>
          <Typography component="p" sx={songStyle.tokenSectionTitle}>
            Buy NFTs
          </Typography>
          <Typography component="p" sx={songStyle.songDescription}>
            When you purchase a NFT in support of an artist, you own a part of
            the streaming royalty for the song with them. This means that as the
            song streams, you become eligible to get a percentage of the royalty
            income that accrue.
          </Typography>
          <Box sx={songStyle.boxRow}>
            {data?.attributes?.asset_tiers?.data.map((assetTiers) => {
              const Nftprice = assetTiers?.attributes?.starting_bid;
              return (
                <NftCard
                  key={assetTiers.id}
                  assetTiers={assetTiers}
                  Nftprice={Nftprice}
                  data={data}
                  isMobile={isMobile}
                  songName={data?.attributes?.Title}
                  artistName={
                    data?.attributes?.artists?.data[0]?.attributes?.name
                  }
                />
              );
            })}

            {/* <Box sx={songStyle.featuredBox}>
              <Box component="img" src="./images/token/1.png" />
              <Box sx={songStyle.packageBox}>
                <Box sx={songStyle.tokenContentTitle}>
                  <Typography component="p" sx={songStyle.packageName}>
                    Silver
                  </Typography>
                  <Typography component="p" sx={songStyle.packagePrice}>
                    $5
                  </Typography>
                </Box>
                <Typography component="p" sx={songStyle.packageSubTitle}>
                  0.0040% - Ownership Per NFT
                </Typography>
                <Box sx={songStyle.benefitListBox}>
                  <Typography component="p" sx={songStyle.packageBenefitsTitle}>
                    <Box component="img" src="./images/token/star.png" /> Benefits
                  </Typography>
                  <Typography component="p" sx={songStyle.packageBenefitsList}>
                    <Box component="img" src="./images/token/tick.png" /> Meet &
                    Greet opportunities (backstage, music video shoot, etc)
                    selected Contest
                  </Typography>
                  <Typography component="p" sx={songStyle.packageBenefitsList}>
                    <Box component="img" src="./images/token/tick.png" /> Event
                    passes
                  </Typography>
                </Box>
                <Link href="#" sx={songStyle.moreInfoLink}>
                  More Info
                </Link>
                <Typography
                  component="span"
                  sx={songStyle.dividerLine}
                ></Typography>
                <Box sx={songStyle.tokenContentTitle}>
                  <Typography component="p" sx={songStyle.availToken}>
                    12/390 Available
                  </Typography>
                  <Button variant="contained" sx={songStyle.tokenBuyNow}>
                    Buy Now
                  </Button>
                </Box>
              </Box>
            </Box>
            <Box sx={songStyle.featuredBox}>
              <Box component="img" src="./images/token/2.png" />
              <Box sx={songStyle.packageBox}>
                <Box sx={songStyle.tokenContentTitle}>
                  <Typography component="p" sx={songStyle.packageName}>
                    Gold
                  </Typography>
                  <Typography component="p" sx={songStyle.packagePrice}>
                    $45
                  </Typography>
                </Box>
                <Typography component="p" sx={songStyle.packageSubTitle}>
                  0.0050% - Ownership Per NFT
                </Typography>
                <Box sx={songStyle.benefitListBox}>
                  <Typography component="p" sx={songStyle.packageBenefitsTitle}>
                    <Box component="img" src="./images/token/star.png" /> Silver
                    Benefits, +2 more
                  </Typography>
                  <Typography component="p" sx={songStyle.packageBenefitsList}>
                    <Box component="img" src="./images/token/tick.png" /> Meet &
                    Greet opportunities (backstage, music video shoot, etc)
                    selected Contest
                  </Typography>
                  <Typography component="p" sx={songStyle.packageBenefitsList}>
                    <Box component="img" src="./images/token/tick.png" /> Event
                    passes
                  </Typography>
                </Box>
                <Link href="#" sx={songStyle.moreInfoLink}>
                  More Info
                </Link>
                <Typography
                  component="span"
                  sx={songStyle.dividerLine}
                ></Typography>
                <Box sx={songStyle.tokenContentTitle}>
                  <Typography component="p" sx={songStyle.availToken}>
                    12/390 Available
                  </Typography>
                  <Button variant="contained" sx={songStyle.tokenBuyNow}>
                    Buy Now
                  </Button>
                </Box>
              </Box>
            </Box>
            <Box sx={songStyle.featuredBox}>
              <Box component="img" src="./images/token/3.png" />
              <Box sx={songStyle.packageBox}>
                <Box sx={songStyle.tokenContentTitle}>
                  <Typography component="p" sx={songStyle.packageName}>
                    Gold
                  </Typography>
                  <Typography component="p" sx={songStyle.packagePrice}>
                    $45
                  </Typography>
                </Box>
                <Typography component="p" sx={songStyle.packageSubTitle}>
                  0.0050% - Ownership Per NFT
                </Typography>
                <Box sx={songStyle.benefitListBox}>
                  <Typography component="p" sx={songStyle.packageBenefitsTitle}>
                    <Box component="img" src="./images/token/star.png" /> Gold
                    Benefits, +3 more
                  </Typography>
                  <Typography component="p" sx={songStyle.packageBenefitsList}>
                    <Box component="img" src="./images/token/tick.png" /> Meet &
                    Greet opportunities (backstage, music video shoot, etc)
                    selected Contest
                  </Typography>
                  <Typography component="p" sx={songStyle.packageBenefitsList}>
                    <Box component="img" src="./images/token/tick.png" /> Event
                    passes
                  </Typography>
                  <Typography component="p" sx={songStyle.packageBenefitsList}>
                    <Box component="img" src="./images/token/tick.png" />{" "}
                    Exclusive Bithday Wishes
                  </Typography>
                </Box>
                <Link href="#" sx={songStyle.moreInfoLink}>
                  More Info
                </Link>
                <Typography
                  component="span"
                  sx={songStyle.dividerLine}
                ></Typography>
                <Box sx={songStyle.tokenContentTitle}>
                  <Typography component="p" sx={songStyle.availToken}>
                    12/390 Available
                  </Typography>
                  <Button variant="contained" sx={songStyle.tokenBuyNow}>
                    Buy Now
                  </Button>
                </Box>
              </Box>
            </Box> */}
          </Box>
        </Box>
        <Box sx={songStyle.haveQuestion}>
          <Typography component="p" sx={songStyle.tokenSectionTitle}>
            Have a Question
          </Typography>
          <Box sx={songStyle.details}>
            <Box component="img" src="/images/token/confuse.png" />
          </Box>
          <Box
            style={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Box sx={songStyle.whatsApp}>
              <Box onClick={() => share()}>
                <Box component="img" src="/images/landing/whatsapp.svg" />
                <Typography variant="span">Reach Us</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={songStyle.featuredRow}>
          <Typography component="p" sx={songStyle.tokenSectionTitle}>
            Past Performance -{" "}
            {data?.attributes?.artists?.data[0]?.attributes?.name} Songs
          </Typography>
          <Box sx={songStyle.boxRow}>
            {isMobile ? (
              <>
                <Table sx={songStyle.tableUI}>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        variant="th"
                        width="250px !important"
                        style={{ paddingLeft: "16px" }}
                      >
                        Song Name
                      </TableCell>
                      <TableCell width="90px" variant="th">
                        YouTube
                      </TableCell>
                      <TableCell width="90px" variant="th">
                        Spotify
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody sx={songStyle.tblBody}>
                    {artistsongInfo &&
                      artistsongInfo.length > 0 &&
                      artistsongInfo.map((item, key) => {
                        return (
                          <TableRow key={item.id}>
                            <TableCell width="200px">
                              <Typography
                                component="p"
                                sx={songStyle.releaseDate}
                              >
                                {moment(item?.attributes?.release_date).format(
                                  "DD MMM YYYY"
                                )}
                              </Typography>
                              <Box
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Box
                                  component="img"
                                  src={item?.attributes?.thumbnail_url}
                                />
                                <Typography
                                  component="p"
                                  sx={songStyle.tblsongName}
                                >
                                  {item?.attributes?.songname}
                                  <br />
                                  <span
                                    style={{
                                      color: "#E14084",
                                      fontWeight: 700,
                                    }}
                                  >
                                    {(
                                      Math.abs(
                                        Number(item?.attributes.total_streams)
                                      ) / 1.0e6
                                    ).toFixed(1) + "M"}{" "}
                                    Total Streams
                                  </span>
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell width="90px">
                              <Box
                                style={{ cursor: "pointer" }}
                                component="img"
                                src="/images/token/yt-white.png"
                                onClick={() =>
                                  handleOpen(item?.attributes?.youtube_embed_id)
                                }
                              />
                            </TableCell>
                            <TableCell width="90px">
                              <Box
                                style={{ cursor: "pointer" }}
                                component="img"
                                src="/images/token/Play-stream.svg"
                                onClick={() => {
                                  setArtistAudiopopup(true);
                                  setSportifyUrlKey(
                                    item?.attributes?.spotify_track_id
                                  );
                                  window.open(
                                    SportifyUrl +
                                      `${item?.attributes?.spotify_track_id}`,
                                    "_blank"
                                  );
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </>
            ) : (
              <>
                <Table sx={songStyle.DesktoptableUI}>
                  <TableHead>
                    <TableRow style={{ fontSize: "20px" }}>
                      <TableCell
                        variant="th"
                        width="250px"
                        style={{ paddingLeft: "16px" }}
                      >
                        Song Name
                      </TableCell>
                      <TableCell variant="th" width="100px">
                        Release
                      </TableCell>
                      <TableCell variant="th" width="100px">
                        Total Streams{" "}
                        <Tooltip
                          arrow
                          title={
                            <ToolTipText text="Sum of Streams for all streaming partners (Spotify, Gaana, Saavn, Wynk etc) and Total Views on Youtube." />
                          }
                          placement="top-start"
                        >
                          <Box
                            mt={"-10px"}
                            component="img"
                            src="/images/token/info.svg"
                          />
                        </Tooltip>
                      </TableCell>
                      <TableCell variant="th" width="100px">
                        YouTube
                      </TableCell>
                      <TableCell variant="th" width="100px">
                        Spotify
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {artistsongInfo &&
                      artistsongInfo.length > 0 &&
                      artistsongInfo.map((item, key) => {
                        return (
                          <TableRow key={item.id}>
                            <TableCell
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Box
                                component="img"
                                src={item?.attributes?.thumbnail_url}
                                style={{
                                  width: "70px",
                                  height: "70px",
                                  border: "1px solid #FFFFFF",
                                  borderRadius: "4px",
                                }}
                              />
                              <Typography
                                component="p"
                                sx={songStyle.DesktopTblsongName}
                              >
                                {item?.attributes?.songname}
                              </Typography>
                            </TableCell>
                            <TableCell width="100px">
                              {" "}
                              {moment(item?.attributes?.release_date).format(
                                "DD MMM YYYY"
                              )}
                            </TableCell>
                            <TableCell
                              width="100px"
                              style={{ color: "#E14084", fontWeight: 700 }}
                            >
                              {(
                                Math.abs(
                                  Number(item?.attributes.total_streams)
                                ) / 1.0e6
                              ).toFixed(0) + " Mn+"}
                            </TableCell>
                            <TableCell width="100px">
                              <Box
                                style={{
                                  cursor: "pointer",
                                  height: "36px",
                                  width: "36px",
                                }}
                                component="img"
                                src="/images/token/yt-white.png"
                                onClick={() =>
                                  handleOpen(item?.attributes?.youtube_embed_id)
                                }
                              />
                            </TableCell>

                            <TableCell width="100px">
                              <Box
                                style={{ cursor: "pointer" }}
                                component="img"
                                src="/images/token/Play-stream.svg"
                                onClick={() => {
                                  setArtistAudiopopup(true);
                                  setSportifyUrlKey(
                                    item?.attributes?.spotify_track_id
                                  );
                                  window.open(
                                    SportifyUrl +
                                      `${item?.attributes?.spotify_track_id}`,
                                    "_blank"
                                  );
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </>
            )}
            {/* For youtoube videos */}
            <Modal open={artistVideopopup} onClick={handleClose}>
              <Box sx={songStyle.SongVideos}>
                <iframe
                  width="640"
                  height="320"
                  src={Url + urlKey + "?autoplay=1"}
                  title="Top 5 Songs"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </Box>
            </Modal>

            {/* <Modal
              open={artistAudiopopup}
              onClick={() => {
                setArtistAudiopopup(false);
              }}
            >
              <Box sx={songStyle.SongAudio}>
                <iframe
                  width="500"
                  height="300"
                  src={SportifyUrl + sportifyUrlKey}
                  title="Song ----1"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </Box>
            </Modal> */}
          </Box>
        </Box>
        <Box sx={songStyle.featuredRow}>
          <Typography component="p" sx={songStyle.tokenSectionTitle}>
            About {data?.attributes?.artists?.data[0]?.attributes?.name}
          </Typography>
          <Typography component="p" sx={songStyle.songDescription}>
            {data?.attributes?.artists?.data[0]?.attributes?.description}
          </Typography>
          <Box sx={songStyle.statsContainer}>
            <Box sx={songStyle.details}>
              <Box
                component="img"
                src="/images/Instagram.svg"
                width="48px"
                height="48px"
              />
              <Box>
                <Typography sx={songStyle.userName} variant="span">
                  {" "}
                  {artistSocialMediadata?.instagram_followers}{" "}
                </Typography>
                <Typography sx={songStyle.tab} variant="span">
                  {" "}
                  Followers{" "}
                </Typography>
              </Box>
            </Box>
            <Box sx={songStyle.details}>
              <Box
                component="img"
                src="/images/FBlogo.svg"
                width="48px"
                height="48px"
              />
              <Box>
                <Typography sx={songStyle.userName} variant="span">
                  {" "}
                  {artistSocialMediadata?.facebook_followers}{" "}
                </Typography>
                <Typography sx={songStyle.tab} variant="span">
                  {" "}
                  Followers{" "}
                </Typography>
              </Box>
            </Box>

            <Box sx={songStyle.details}>
              <Box
                component="img"
                src="/images/token/gaana.png"
                width="48px"
                height="48px"
                style={{ borderRadius: "50px" }}
              />
              <Box>
                <Typography sx={songStyle.userName} variant="span">
                  {" "}
                  {artistSocialMediadata?.gaana_followers}{" "}
                </Typography>
                <Typography sx={songStyle.tab} variant="span">
                  {" "}
                  Followers{" "}
                </Typography>
              </Box>
            </Box>
            <Box sx={songStyle.details}>
              <Box
                component="img"
                src="/images/token/spotify.png"
                width="48px"
                height="48px"
              />
              <Box>
                <Typography sx={songStyle.userName} variant="span">
                  {" "}
                  {artistSocialMediadata?.monthly_listners}{" "}
                </Typography>
                <Typography sx={songStyle.tab} variant="span">
                  {" "}
                  Monthly Listeners{" "}
                </Typography>
              </Box>
            </Box>
          </Box>
          {/* <Box sx={songStyle.featuredRow}>
        <Typography component="p" sx={songStyle.tokenSectionTitle}>
          Information
        </Typography>
        <Typography component="p" sx={songStyle.songDescription}>
          When you purchase a token in support of an artist, you own a part of
          the streaming rights with them. This means that as the song streams,
          you will get a percentage of the royalties that accrue.
        </Typography>
        <Box sx={songStyle.boxRow}>
          <Box sx={songStyle.chartContainer}>
            <Box sx={songStyle.statsContainer}>
              <List sx={songStyle.listBox}>
                <ListItem sx={songStyle.listItemBox}>
                  <Box>
                    <Typography component="small">Edition</Typography>
                    <Typography component="p">
                      {data.attributes?.Title}
                    </Typography>
                  </Box>
                </ListItem>
                <ListItem sx={songStyle.listItemBox}>
                  <Box>
                    <Typography component="small">Contract Address</Typography>
                    <Typography component="p">
                      <a
                        rel="noreferrer"
                        href={data.attributes?.contract_address}
                        target="_blank"
                      >
                        {data.attributes.contract_address?.substring(39, 45)}...
                        {data.attributes.contract_address?.substring(77, 81)}
                      </a>
                    </Typography>
                  </Box>
                </ListItem>
                <ListItem sx={songStyle.listItemBox}>
                  <Box>
                    <Typography component="small">Amount Raised</Typography>
                    <Typography component="p">
                      ${data.attributes?.amount_to_be_raised}
                    </Typography>
                  </Box>
                </ListItem>
                <ListItem sx={songStyle.listItemBox}>
                  <Box>
                    <Typography component="small">Legal</Typography>
                    <Typography component="p">
                      <a
                        rel="noreferrer"
                        href={data.attributes?.legal_contract}
                        target="_blank"
                      >
                        Read Now
                      </a>
                    </Typography>
                  </Box>
                </ListItem>
                <ListItem sx={songStyle.listItemBox}>
                  <Box>
                    <Typography component="small">Blockchain</Typography>
                    <Typography component="p">
                      {data.attributes?.blockchain}
                    </Typography>
                  </Box>
                </ListItem>
                <ListItem sx={songStyle.listItemBox}>
                  <Box>
                    <Typography component="small">OpenSea Link</Typography>
                    <Typography component="p">
                      <a
                        rel="noreferrer"
                        href="https://testnets.opensea.io/collection/unidentified-contract-uhtplmci2j"
                        target="_blank"
                      >
                        Click here.
                      </a>
                    </Typography>
                  </Box>
                </ListItem>
              </List>
            </Box>
            <Box sx={songStyle.pieChartBox}>
              <Typography component="p">Royalties</Typography>
              <PieChart data={royalties} />
            </Box>
          </Box>
        </Box>
      </Box> */}
        </Box>
        {/*       
        <Collectors/> */}
        {typeof data != "undefined" && (
          <Box sx={songStyle.featuredRow}>
            <FAQs slug={data?.attributes?.nft_slug?.split("/")[2]} />
          </Box>
        )}
        <Box sx={songStyle.featuredRow}>
          <FollowUs />
        </Box>
      </Box>
      <Modal open={open} onClick={() => setOpen(false)}>
        <SocialShareComponent
          style={{ left: "85%", top: "28%" }}
          nftLink={nftLink}
          tokenType="song"
        />
      </Modal>
      {calculator && (
        <Popup noCloseButton handlePopupClose={() => setCalculator(false)}>
          <ReturnCalculator
            tierData={data?.attributes}
            closePopup={() => setCalculator(false)}
          >
            {" "}
          </ReturnCalculator>
        </Popup>
      )}
      {snackbar.show ? <SnackBar {...snackbar} onClose={setSnackbar} /> : null}
      <Modal open={enquireNowPopup} onClose={() => setEnquireNowPopup(false)}>
        <div className="main-form-section">
          <button
            type="button"
            className="close clse-btn"
            style={{
              color: "#FFF",
              position: "relative",
              zIndex: "4",
              top: "15px",
            }}
            aria-label="Close"
            onClick={() => setEnquireNowPopup(false)}
          >
            <span aria-hidden="true" style={{ color: "#FFF" }}>
              <img src="/images/calculator/close.svg" />
            </span>
          </button>
          <CapturePhone
            enquireNow={true}
            toggleSnackbar={(val) => setSnackbar(val)}
            handleModalClose={() => setEnquireNowPopup(false)}
          />
        </div>
      </Modal>

      {howitWorks && (
        <Popup
          noCloseButton
          noFullScreen={isMobile ? false : true}
          handlePopupClose={() => setHowitWorks(false)}
        >
          <Grid direction="row" sx={songStyle.headerItems}>
            <Grid onClick={() => setHowitWorks(false)}>
              <img
                src="/images/calculator/close.svg"
                // src="/images/token/tick-dark.png"
                alt="go back a step"
                width="35"
                height="35"
                style={{ paddingTop: "10px" }}
              />
            </Grid>
            <Grid style={{ margin: "auto" }}>
              <Typography variant="h1" sx={songStyle.HIWtitle}>
                {"How it Works!"}
              </Typography>
            </Grid>
          </Grid>
          <Box>
            <HowItWorks songPage={true} />
          </Box>
        </Popup>
      )}
    </Box>
  );
};
export default SongDetails;
